import type { Dispatch } from 'redux';
import {
    DistributionList,
    createActionFactory,
    createDataActionFactory,
    Feature,
    PersonType,
    PrivateDistributionList,
} from '../../../shared';
import {
    DistributionListIdentifier,
    default as getDistributionListInfo,
} from '../../dataLayer/ows/distributionList/getDistributionListInfo';
import getPrivateDistributionListNotes from '../../dataLayer/ows/distributionList/getPrivateDistributionListNotes';

export type { PrivateDistributionList };

export type LoadedDistritbutionList = { distributionList: DistributionList; folderId: string };

export const distributionListLoadCompletedAction = createDataActionFactory<
    LoadedDistritbutionList,
    { hubPersonaId: string; type: PersonType; error: Error }
>('DistributionListLoadCompletedAction', Feature.DistributionLists);

export const distributionListLoadStartAction = createActionFactory<{ hubPersonaId: string }>(
    'PrivateDistributionListLoadStartAction',
    Feature.DistributionLists
);

export const privateDistributionListNotesLoadCompletedAction = createDataActionFactory<
    { hubPersonaId: string; notes: string },
    { hubPersonaId: string; error: Error }
>('PrivateDistributionListNotesLoadCompletedAction', Feature.DistributionLists);

export const privateDistributionListNotesLoadStartAction = createActionFactory<{
    hubPersonaId: string;
}>('PrivateDistributionListNotesLoadStartAction', Feature.DistributionLists);

export const getDistributionList = (dispatch: Dispatch) => (
    personaId: string,
    hubPersonaId: string,
    contactFolderId: string,
    distributionListIdentifier: DistributionListIdentifier
): void => {
    dispatch(distributionListLoadStartAction({ hubPersonaId }));

    getDistributionListInfo(personaId, contactFolderId, distributionListIdentifier).then(
        distributionList => {
            dispatch(
                distributionListLoadCompletedAction.success({
                    distributionList,
                    folderId: undefined,
                })
            );
        },
        error => {
            dispatch(
                distributionListLoadCompletedAction.error({
                    hubPersonaId: hubPersonaId,
                    type: distributionListIdentifier.type,
                    error,
                })
            );
        }
    );
};

export const getDistributionListAndNotes = (dispatch: Dispatch) => (
    personaId: string,
    hubPersonaId: string,
    contactFolderId: string,
    distributionListIdentifier: DistributionListIdentifier
): void => {
    getDistributionList(dispatch)(
        personaId,
        hubPersonaId,
        contactFolderId,
        distributionListIdentifier
    );

    if (distributionListIdentifier.type === PersonType.PrivateDistributionList) {
        dispatch(privateDistributionListNotesLoadStartAction({ hubPersonaId }));
        getPrivateDistributionListNotes(personaId, contactFolderId).then(
            notes => {
                dispatch(
                    privateDistributionListNotesLoadCompletedAction.success({ hubPersonaId, notes })
                );
            },
            error => {
                dispatch(
                    privateDistributionListNotesLoadCompletedAction.error({ hubPersonaId, error })
                );
            }
        );
    }
};
export type { PublicDistributionList } from '../../../shared';
export type { Action } from '../../../shared';
export type { DataActionFactory } from '../../../shared';
